__turbopack_context__.v({
  "isActive": "track-module-scss-module__xA_JcG__isActive",
  "isDisabled": "track-module-scss-module__xA_JcG__isDisabled",
  "track": "track-module-scss-module__xA_JcG__track",
  "trackBackground": "track-module-scss-module__xA_JcG__trackBackground",
});
